/* js/headerMain.js */

jQuery(document).ready(function ($) {

    $(window).scroll(function () {
        var top = 10;
        if ($(window).scrollTop() >= top) {

            $('body').addClass('headerMain-is-scrolled');

            if ($('.headerMain-toolBar').length) {

                var topBarHeight = $('.topBar-block').outerHeight();
                $('.headerMain-toolBar').css('top', -topBarHeight);
            }


        } else {
            $('body').removeClass('headerMain-is-scrolled');
            if ($('.headerMain-toolBar').length) {
                $('.headerMain-toolBar').css('top', '0');
            }
        }
    });
});
